<template>
  <div
    v-if="visible"
    class="base-sidebar omnica-modal-sidebar-overlay"
    @click.self="close"
  >
    <!-- Анимация для выезда sidebar -->
    <transition name="sidebar-slide">
      <aside class="omnica-modal-sidebar omnica-modal-sidebar_size_lg" v-if="visible">
        <div style="display: flex;height: 100%;">
<div style="display: flex; flex-direction: column; height: 100%; width: 100%;">
        
        <!-- Заголовок -->
        <header class="omnica-modal-sidebar__header">
          <div class="omnica-modal-sidebar__header-inner">
            <div class="omnica-modal-sidebar__title">
              <div class="sidebar-head__title">
                
                <span v-if="chat.source && chat.source.type && chat.source.type.id === 'telegram'" class="iconMess">
                    <i data-v-008bfe74="" data-v-15cce238="" class="-icon fab fa-telegram-plane img-icon fa-fw mr-2" style="background-image: url(&quot;https://static.me-talk.ru/cabinet/assets/images/logo/telegram-plane.svg&quot;) !important; background-repeat: no-repeat !important; background-size: 1em !important; background-position: center center !important;"></i>
                </span>
                <span v-if="chat.source && chat.source.type && chat.source.type.id === 'viber'" class="iconMess">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#fff" width="24px" height="24px"><rect width="512px" height="512px" rx="15%" fill="#665ca7"/><path fill="none" stroke="#fff" stroke-linecap="round" stroke-width="10" d="M269 186a30 30 0 0 1 31 31m-38-58a64 64 0 0 1 64 67m-73-93a97 97 0 0 1 99 104"/><path fill-rule="evenodd" d="M95 232c0-91 17-147 161-147s161 56 161 147-17 147-161 147l-26-1-53 63c-4 4-8 1-8-3v-69c-6 0-31-12-38-19-22-23-36-40-36-118zm-30 0c0-126 55-177 191-177s191 51 191 177-55 177-191 177c-10 0-18 0-32-2l-38 43c-7 8-28 11-28-13v-42c-6 0-20-6-39-18-19-13-54-44-54-145zm223 42q10-13 24-4l36 27q8 10-7 28t-28 15q-53-12-102-60t-61-104q0-20 25-34 13-9 22 5l25 35q6 12-7 22c-39 15 51 112 73 70z"/></svg>
                </span>
                
                Чат с пользователем: <span v-if="chat.dialog.client.firstName" style="margin-left: 5px;"> {{ chat.name }}</span>
              </div>
            </div>  



            <button
              role="button"
              aria-label="Esc"
              class="omnica-modal-sidebar__close"
              @click="close"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="32" class="omnica-popper-target"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
            </button>
          </div>
        </header>

        <!-- Основное содержание -->
        <div class="omnica-modal-sidebar__body" >

              <div class="el-card-section pt-0 pb-0">
                <div class="core-ui-chat-history">


        <div v-for="message in reversedMessages" :key="message.id"
        :class="[
            'chat-history-message',
            `chat-history-message-${message.id}`,
            message.whoSend === 'client' ? 'color-client-default' : 'color-blue',
            message.whoSend === 'operator' ? 'operator' : 'client',
            message.isVisibleForClient ? 'last-message-of' : '',
            'short-margin',
            'is-bubble-message'
        ]">

        <div class="d-flex inner">
                      <div class="message-wrapper flex-fill">
                        <div class="message-background-container message-background message-content-color">
                          <div class="sender-name message-color">
                            {{ message.whoSend === 'client' ? 'Посетитель' : message.operatorName || 'Оператор' }}
                            <i v-if="message.whoSend === 'client'" class="-icon fal fa-arrow-right"></i>
                          </div>
                          <div class="message-text">
                            {{ message.text }}
                          </div>
                          <div class="time message-color time">
                            <span class="time-value">{{ message.dateTime }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="core-ui-avatar avatar" :style="{ background: 'rgb(189, 195, 199)', width: '30px', height: '30px', minWidth: '30px' }" v-if="message.whoSend === 'operator'">
                       <img v-if="chat.operators && chat.operators[0] && chat.operators[0].avatar" :src="chat.operators[0].avatar" alt="avatar" />

                        <span v-else class="status text-status-1" style="font-size: 30px;">
                          <span class="status-circle"></span>
                        </span>
                      </div>
                    </div>

        </div>
</div>
</div>


        </div> 
         <footer class="omnica-modal-sidebar__footer">
                                <div class="blockSending">
                <div style="width: 75%;">
                    <div class="core-ui-avatar avatar avmes" :style="{ background: 'rgb(189, 195, 199)', width: '30px', height: '30px', minWidth: '30px' }" v-if="chat.operators">
                       <img v-if="chat.operators && chat.operators[0] && chat.operators[0].avatar" :src="chat.operators[0].avatar" alt="avatar" />

                        <span v-else class="status text-status-1" style="font-size: 30px;">
                          <span class="status-circle"></span>
                        </span>
                      </div>
                    <textarea 
                        name="poleMessages" 
                        id="poleMess"
                        v-model="messageText"
                        @input="handleTyping"
                        @keydown.enter.prevent="sendMessageHandler"
                        placeholder="Введите сообщение..."
                    ></textarea>  
                </div>
                <div @click="sendMessageHandler" style="width: 25%;">
                    <div class="butSending">Отправить</div>
                </div>
            </div>
            
            <!-- Индикатор набора текста клиентом -->
            <div v-if="isClientTyping" class="typing-indicator">
                <span class="typing-text">Клиент печатает...</span>
                <div class="typing-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </footer>


    </div>



</div>
      </aside>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';    
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Russian } from "flatpickr/dist/l10n/ru.js";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
    },
    chat: {
        type: Object,
        default: null
    }
  },
  components: {
    flatPickr,
    vSelect,
  },
  data() {
    return {
      flatpickrConfig: {
        locale: Russian, // Русификация
        enableTime: true, // Включаем выбор времени
        dateFormat: "d.m.Y H:i", // Формат даты
        time_24hr: true, // 24-часовой формат времени
      },
      messageText: '',
      localIsTyping: false,
      typingTimeout: null
    };
  },
  computed: {
    ...mapGetters('chatModule', ['isTyping']),
    reversedMessages() {
      console.log('Chat в computed:', this.chat);
      console.log('Messages в chat:', this.chat && this.chat.messages);
      return Array.isArray(this.chat && this.chat.messages)
        ? [...this.chat.messages].reverse()
        : [];
    },
    isClientTyping() {
      return this.chat && this.isTyping(this.chat.dialog.clientId);
    }
  },
  methods: {
    ...mapActions('chatModule', [
      'sendMessage',
      'sendTypingStatus',
      'getClientMessages',
      'markMessageAsRead'
    ]),
    
    close() {
        this.$emit("close");
        this.messageText = '';
    },
    
    async sendMessageHandler(){
        console.log('Попытка отправить сообщение');
        console.log('messageText:', this.messageText);
        console.log('chat:', this.chat);
        
        if (!this.messageText.trim() || !this.chat) {
            console.log('Не удается отправить - пустой текст или нет чата');
            return;
        }
        
        try {
            console.log('Отправляем сообщение:', {
                clientId: this.chat.dialog.clientId,
                messageText: this.messageText.trim()
            });
            
            await this.sendMessage({
                clientId: this.chat.dialog.clientId,
                messageText: this.messageText.trim()
            });
            
            console.log('Сообщение отправлено успешно');
            this.messageText = '';
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        } catch (error) {
            console.error('Ошибка отправки сообщения:', error);
            this.$toast.error('Ошибка отправки сообщения');
        }
    },
    
    handleTyping() {
        if (!this.chat) return;
        
        // Отправляем статус набора текста
        this.sendTypingStatus({ clientId: this.chat.dialog.clientId });
        
        // Сбрасываем предыдущий таймаут
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
        }
        
        // Устанавливаем новый таймаут
        this.typingTimeout = setTimeout(() => {
            this.localIsTyping = false;
        }, 3000);
    },
    
    scrollToBottom() {
        const chatContainer = this.$el.querySelector('.core-ui-chat-history');
        if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
        }
    },
    
    getReverse(chatmess){
        return chatmess.reverse();
    },
    
    async loadMoreMessages() {
        if (!this.chat) return;
        
        try {
            await this.getClientMessages({
                clientId: this.chat.dialog.clientId,
                limit: 30,
                page: Math.floor(this.chat.messages.length / 30)
            });
        } catch (error) {
            console.error('Ошибка загрузки сообщений:', error);
        }
    }
  },
};
</script>

<style scoped>



.side-menu-card-section .side-menu-field-descr {
    color: #818ea3;
    font-size: .9em;
    letter-spacing: .05em;
}

.avmes {
    top: -10px;
    right: 10px;
}

.blockSending {
    display: flex;
    justify-content: center;
    align-items: center;
}

.butSending {
    padding: 10px 30px;
    background: #0074f0;
    color: #fff;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid #0074f0;
    transition: 0.3s;
}

#poleMess {
    height:  70px !important;
    width: 85%;
}
.iconMess {
    margin-right: 12px;
}
.iconMess i{
    width: 24px;
    height: 24px;
    display: block;
    position: relative;
    top: 3px;
}

.blockvnechLink{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}
.blockvnechLink .vnechLink {
    padding: 10px 30px;
    background: #0074f0;
    color: #fff;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid #0074f0;
    transition: 0.3s;;
    width: 100%;
}

.blockvnechLink .vnechLink:hover {
    background: transparent;
    color: #0074f0;
}
/* Задний фон */
.base-sidebar {
  width: 100%;
  height: 100%;
  background: rgba(45,51,108,.4);
  display: flex;
  justify-content: flex-end;
}

/* Сайдбар */
.omnica-modal-sidebar {
  width: 400px;
  background: #fff;
  display: flex;
  flex-direction: column;
  /*transform: translateX(100%);*/ /* Исходное положение - за экраном */
}



.omnica-modal-sidebar {
    background: #fff;
    bottom: 0;
    box-shadow: 0 8px 16px rgb(30 34 72 / 16%);
    display: flex;
    flex-direction: column;
    height: 100%;
    left: auto;
    right: 0;
    top: 0;
    width: 416px;
}


.omnica-modal-sidebar_size_lg {
    width: 1000px;
}



.omnica-modal-sidebar__header {
    align-items: center;
    border-bottom: 1px solid #dee2e6;
    display: flex;
    flex: 0 1 68px;
    justify-content: space-between;
    min-height: 68px;
    padding: 0 24px 0 32px;
    position: relative;
}

.omnica-modal-sidebar__body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 24px 32px;
    max-height: 400px;
}

.omnica-modal-sidebar__header-inner {
    align-items: center;
    display: flex;
    min-width: 0;
    padding-right: 16px;
}

.omnica-modal-sidebar__title {
    color: #0d0f1f;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.33333333;
}

.sidebar-head {
    align-items: center;
    display: flex;
}

.sidebar-head__title {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
}

.omnica-modal-sidebar__close {
    color: #afb9c3;
    cursor: pointer;
    height: 32px;
    position: absolute;
    right: 17px;
    top: 18px;
    transition: color .25s ease;
    width: 32px;
    background: transparent;
    border: 0px;
    transition: 0.3s;
}



.ps {
    -ms-overflow-style: none;
    overflow: hidden!important;
    overflow-anchor: none;
    touch-action: auto;
    -ms-touch-action: auto;
}

.ps, .ps * {
    box-sizing: border-box;
}

.ps {
    position: relative;
}

.omnica-modal-sidebar__footer {
    background: #f9fafb;
    padding: 10px;
}

.sidebar-form__item:first-child {
    margin-top: 0;
}

.sidebar-form__label {
    color: #8a96a6;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.42857143;
    margin-bottom: 4px;
}

.UiInput-input-3imQ {
    align-items: center;
    display: flex;
    transition: .25s ease;
}


.UiInput-input__area-2i6h {
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    position: relative;
    width: 100%;
}

.UiInput-input__area-2i6h {
    height: 36px;
    padding: 0 10px;
}

.UiTextarea-textarea_default-26FY {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-height: 96px;
}

.UiTextarea-textarea__area-1IwX {
  background: #fff!important;
    border-radius: 6px!important;
    color: #1e2248!important;
    padding: 8px 16px!important;
}


.omnica-modal-sidebar__close:hover {
    color: #636f7f;
    transform: rotate(180deg);
}


.datepicker,
.timepicker {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
}

.omnica-button {
    --omnica-button-text-color: #1e2248;
    appearance: none;
    background-image: none;
    border: none;
    border-radius: 6px;
    box-sizing: border-box;
    color: var(--omnica-button-text-color);
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
    line-height: normal;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    touch-action: manipulation;
    transition: color .25s ease,background .25s ease,box-shadow .25s ease,border .25s ease,width 0s;
    user-select: none;
    vertical-align: top;
    white-space: nowrap;
}

.omnica-button_primary {
    --omnica-button-background-color: #005eeb;
    --omnica-button-background-color-active: #0052cc;
    --omnica-button-background-color-disabled: #b8dbff;
    --omnica-button-background-image: linear-gradient(180deg,#0068ff,#005bd5);
    --omnica-button-text-color: #fff;
    background-color: var(--omnica-button-background-color);
    background-image: var(--omnica-button-background-image);
    font-weight: 500;
    margin-left: 10px;
    color: #fff;
}
.omnica-button, .omnica-button:active, .omnica-button:focus {
    box-shadow: none;
    outline: none!important;
}
.omnica-button_secondary {
    background-color: #f4f6f8;
    background-image: linear-gradient(180deg,#fff,#e9ecee);
    border: 1px solid #dee2e6;
}

.omnica-button_sm {
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    height: 36px;
    line-height: normal;
    min-width: 96px;
    padding: 0 20px;
}
.omnica-button__inner {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.omnica-button_ellipsis .omnica-button__text {
    overflow: hidden;
    text-overflow: ellipsis;
}

.flatpickr {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
}


/* Анимация для выезда */
.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: transform 0.3s ease-out;
}

.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(100%); /* Скрытое положение */
}

.sidebar-slide-enter-to,
.sidebar-slide-leave-from {
  transform: translateX(0); /* Позиция видна */
}



.el-card-section, .el-card__body, .el-collapse-item__header {
    padding: 1rem;
}


.el-card-section {
    background: #fff;
    margin: 0 -1rem;
    position: relative;
    height: 100%;
}

.el-card-section {
    border-bottom: 1px solid #e4e7ed;
}



.d-inline-block {
    display: inline-block!important;
}

.flex-fill {
    -webkit-box-flex: 1!important;
    -webkit-flex: 1 1 auto!important;
    -ms-flex: 1 1 auto!important;
    flex: 1 1 auto!important;
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}




.ml-2, .mx-2 {
    margin-left: 0.5rem!important;
}

.text-nowrap {
    white-space: nowrap!important;
}

.font-weight-normal {
    font-weight: 400!important;
}



.el-card-section:last-child {
    border-bottom: 0;
}

.el-card-section, .el-card__body, .el-collapse-item__header {
    padding: 1rem;
}

.el-card-section>:last-child.el-card-section, .el-card-section>:last-child.el-form-wraper, .el-card-section>:last-child.my-table-wrapper, .el-card__body>:last-child.el-card-section, .el-card__body>:last-child.el-form-wraper, .el-card__body>:last-child.my-table-wrapper {
    margin-bottom: -1.1rem;
}

:last-child>.el-card-section:last-child {
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;
}

.core-ui-chat-history {
  display: flex;
  flex-direction: column-reverse; /* Последнее сообщение будет внизу */
 
}


.core-ui-chat-history .centered-bubble-info {
    color: var(--el-color-primary);
    padding: 0.75em 0;
    pointer-events: none;
    text-align: center!important;
    z-index: 1;
}

.core-ui-chat-history .centered-bubble-info>span {
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background: hsla(0,0%,100%,.85);
    background: var(--transparent-info-block-background);
    border-radius: 16px;
    -webkit-box-shadow: 0 2px 5px 0 rgb(50 50 105 / 15%), 0 1px 1px 0 rgb(0 0 0 / 5%);
    box-shadow: 0 2px 5px 0 rgb(50 50 105 / 15%), 0 1px 1px 0 rgb(0 0 0 / 5%);
    display: inline-block;
    padding: 0.5em 1em;
    pointer-events: all;
}



.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
    font-size: 11px;
}


.chat-history-message.color-blue {
    --message-background-color: #b3e5fc;
    --message-background-shadow-color: #9addfb;
    --message-background-darken-color: #275970;
}



.chat-history-message.operator>.inner {
    padding-left: 60px;
}


.chat-history-message.operator.short-margin>.inner {
    padding-left: 15px;
}







.chat-history-message .message-wrapper{
    min-width: 0;
}



.chat-history-message .message-background-container {
    border-radius: 10px;
    display: inline-block;
    max-width: 100%;
    padding: 0.75em;
    position: relative;
    text-align: left;
}

.chat-history-message.color-blue .message-background {
    background: #b3e5fc;
}

.chat-history-message.color-blue .message-background-container {
    border-color: #b3e5fc;
    -webkit-box-shadow: 0 2px 0 #9addfb;
    box-shadow: 0 2px 0 #9addfb;
}


.chat-history-message.color-blue .message-content-color {
    color: #2b2d30;
}

.chat-history-message.operator.last-message-of .message-background-container{
    border-bottom-right-radius: 0;
}

.chat-history-message.operator .message-wrapper{
    text-align: right;
}




.chat-history-message .sender-name {
    font-weight: 500;
    margin-bottom: 0.5em;
    word-break: break-word;
}

.chat-history-message.color-blue .message-color {
    color: #275970;
}


.chat-history-message .message-text {
    word-break: break-word;
    line-height: 16px;
}

.htmlify.pre {
    white-space: pre-wrap!important;
}


.time-value {
  font-size: 10px;
}

.time {
    float: right;
    margin: 0.3em 0 0 1em;
}


.chat-history-message.color-blue .message-color {
    color: #275970;
}



.chat-history-message.last-message-of .message-background-container:after {
    border: solid rgba(0,0,0,0);
    border-width: 0.4em 0 0;
    bottom: 0;
    -webkit-box-shadow: inherit;
    box-shadow: inherit;
    content: " ";
    height: 0;
    position: absolute;
    width: 0;
}


.chat-history-message.operator.last-message-of .message-background-container:after {
    border-left-color: inherit;
    border-left-width: 0.6em;
    left: 100%;
}




.core-ui-avatar {
    border-radius: 50%;
    color: #fff;
    display: inline-block;
    position: relative;
    text-align: center;
}

.chat-history-message .avatar {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    visibility: hidden;
}

.chat-history-message.last-message-of .avatar {
    visibility: visible;
}


.chat-history-message.operator .avatar {
    margin-left: 1em;
}




.text-status-1 {
    color: #1abc9c!important;
}


.core-ui-avatar .status {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.core-ui-avatar .status>span {
    background: #fff;
    border: 2px solid rgba(0,0,0,0);
    border-radius: 50%;
    bottom: -0.3em;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    font-size: .25em;
    height: 1em;
    line-height: 0;
    position: absolute;
    right: -0.3em;
    text-align: center;
    width: 1em;
}



.core-ui-avatar .status>span>* {
    line-height: 1em;
}

.core-ui-avatar .status .status-circle {
    background: currentColor;
    border-radius: 50%;
    display: inline-block;
    height: 100%;
    width: 100%;
}



.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
}

.chat-history-message.color-client-default {
    --message-background-color: #f3f4f9;
    --message-background-shadow-color: #e2e4f1;
    --message-background-darken-color: #44526a;
}

.chat-history-message.client.short-margin>.inner {
    padding-right: 15px;
}

.chat-history-message .message-wrapper {
    min-width: 0;
}

.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
}

.is-system-info {
    padding-bottom: 0.05em;
}

.chat-history-message.color-blue {
    --message-background-color: #b3e5fc;
    --message-background-shadow-color: #9addfb;
    --message-background-darken-color: #275970;
}


.chat-history-message.color-notification {
    --message-background-color: #ffd7b0;
    --message-background-shadow-color: #ffca97;
    --message-background-darken-color: #6f4f03;
}

.is-system-info+.is-system-info{
    padding-top: 0.05em;
}

.chat-history-message.operator.short-margin>.inner{
    padding-left: 15px;
}



.chat-history-message .message-wrapper {
    min-width: 0;
}

.chat-history-message.operator .message-wrapper{
    text-align: right;
}

.system-info-message-container {
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background: hsla(0,0%,100%,.85);
    background: var(--operator-app-system-message-background);
    border-radius: 7px;
    display: inline-block;
    font-size: .9em;
    padding: 0.5em 1em;
}


.chat-history-message.color-client-default .message-background-container {
    background: #f3f4f9;
    border-color: #f3f4f9;
    -webkit-box-shadow: 0 2px 0 #e2e4f1;
    box-shadow: 0 2px 0 #e2e4f1;
}

.chat-history-message.client.last-message-of .message-background-container:after {
    border-right-color: inherit;
    border-right-width: 0.6em;
    right: 100%;
}

.chat-history-message.last-message-of .message-background-container:after {
    border: solid rgba(0,0,0,0);
    border-width: 0.4em 0 0;
    bottom: 0;
    -webkit-box-shadow: inherit;
    box-shadow: inherit;
    content: " ";
    height: 0;
    position: absolute;
    width: 0;
}
.core-ui-avatar.avatar img {
  width: 100%;
}

/* Индикатор набора текста */
.typing-indicator {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-top: 8px;
}

.typing-text {
  font-size: 12px;
  color: #6c757d;
  margin-right: 8px;
}

.typing-dots {
  display: flex;
  gap: 2px;
}

.typing-dots span {
  width: 6px;
  height: 6px;
  background: #6c757d;
  border-radius: 50%;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Стили для textarea в footer */
footer textarea {
  width: 100%;
  min-height: 60px;
  padding: 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.4;
  background: #fff;
  color: #1e2248;
}

footer textarea:focus {
  outline: none;
  border-color: #005eeb;
  box-shadow: 0 0 0 2px rgba(0, 94, 235, 0.1);
}

.butSending {
  background: #005eeb;
  color: white;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
  transition: background-color 0.2s ease;
  font-size: 11px;
}

.butSending:hover {
  background: #0052cc;
}

.blockSending {
  display: flex;
  gap: 2px;
  align-items: center;
}
</style>
